import { render, staticRenderFns } from "./registerpage.vue?vue&type=template&id=58c656b7&scoped=true"
import script from "./registerpage.vue?vue&type=script&lang=js"
export * from "./registerpage.vue?vue&type=script&lang=js"
import style0 from "./registerpage.vue?vue&type=style&index=0&id=58c656b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c656b7",
  null
  
)

export default component.exports